import { CalculatorIcon, FileChartColumnIncreasingIcon, HomeIcon, InboxIcon, RocketIcon, SettingsIcon, UsersIcon } from 'lucide-react'

import { NavItem } from 'shared/dashboard/NavItem'
import { type DashboardEmployersFeatures } from 'utils/web_api.schemas'

interface NavigationProps {
  features: DashboardEmployersFeatures
}

export function Navigation ({ features }: NavigationProps) {
  return (
    <nav className='p-3 space-y-1'>
      {features.home_page_enabled && (
        <NavItem icon={HomeIcon} to='/employers/dashboard' end>Home</NavItem>
      )}
      <NavItem icon={UsersIcon} to='/employers/dashboard/employees'>Employees</NavItem>
      {features.payroll_page_enabled && (
        <NavItem icon={FileChartColumnIncreasingIcon} to='/employers/dashboard/deductions'>Payroll Deductions</NavItem>
      )}
      <NavItem icon={InboxIcon} to='/employers/dashboard/documents'>Documents</NavItem>
      <NavItem icon={RocketIcon} to='/employers/dashboard/resources'>Resources</NavItem>
      <NavItem icon={CalculatorIcon} to='/employers/dashboard/invoices'>Billing</NavItem>
      <NavItem icon={SettingsIcon} to='/employers/dashboard/settings'>Settings</NavItem>
    </nav>
  )
}
